import {useAuthStore} from '~/stores/auth'

export default defineNuxtRouteMiddleware((to, from) => {
  const {$sentrySetUser} = useNuxtApp()
  const authStore = useAuthStore()
  const localeRoute = useLocaleRoute()
  if (!authStore.isLogin) {
    return navigateTo(localeRoute('/auth/login'))
  } else {
    $sentrySetUser({id: authStore.userInfo.id, username: authStore.userInfo.name, email: authStore.userInfo.email})
  }
})
